import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PolicyContent from './components/PolicyContent';
import ConsentSection from './components/ConsentSection';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PolicyContent />
      <ConsentSection />
      <Footer />
    </div>
  );
}
